module.exports = __webpack_public_path__ + "assets/img/tuite.bf209504.png";